export const substitutionType = {
  RANGE: 'RANGE',
  GROUP: 'GROUP',
  PRODUCT: 'PRODUCT',
};
export const MAX_SUBSTITUTIONS_VISIBLE_BY_DEFAULT = 3;
export const substitutionsOrder = {
  [substitutionType.RANGE]: 1,
  [substitutionType.GROUP]: 2,
  [substitutionType.PRODUCT]: 3,
};
export const PRODUCTS_NUMBER_LABEL_PLACEHOLDER = '#number of products#';
